import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";
const basisTypeAPI = createApi({
    reducerPath: 'basisTypeAPI',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({

        addBasisType: builder.mutation({
            query: (data) => ({
                url: `/BasisTypes/AddBasisType`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateBasisType: builder.mutation({
            query: (data) => ({
                url: `/BasisTypes/UpdateBasisType`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getBasisTypeList: builder.mutation({
            query: (data) => ({
                url: `/BasisTypes/GetBasisTypes`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteBasicType: builder.mutation({
            query: (ID) => ({
                url: `/BasisTypes/DeleteBasicType?ID=${ID}`,
                method: `DELETE`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),


    })
})

export const {
    useAddBasisTypeMutation,
    useUpdateBasisTypeMutation,
    useGetBasisTypeListMutation,
    useDeleteBasicTypeMutation
} = basisTypeAPI;


export default basisTypeAPI;